export default "__VITE_ASSET__ae4cc1a4__"